
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  center: {
    flexGrow: 1,
    margin: '10px',
    display: 'flex',
    justifyContent: 'center',
  },
  cardBody: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    margin: 0,
    maxHeight: 'inherit',
    paddingButton: theme.spacing(2),
    paddingTop: theme.spacing(2),
    overflow: 'auto'
  },
  containerInfoComments: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start'
  },
  infoComments: {
    padding: 0,
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.875rem',
    lineHeight: '1.43'
  }
}
))
